import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../../../types';

export const adReportStaticData = {
  menuTitle: MenuTitle.TikTokAdsReport,
  hasCombinedTerms: true
};

export const Route = createFileRoute('/_private-routes/tiktok/ad-campaign-report/')({
  staticData: adReportStaticData
});
